export default __webpack_public_path__ + "static/media/koupelna.57229537.jpeg";